// eslint-disable-next-line import/prefer-default-export
export function formatAlt(alt = '') {
  return alt
    .trim()
    .replace(/\s{2,}/g, ' ')
    .split(' ')
    .slice(0, 2)
    .map((w) => w.slice(0, 1).toUpperCase())
    .join('')
}
